import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M12 1v1.997h-2v1.996h2V6.99h2V4.993h2V2.997h-2V1z" /><path d="M6.492 5.992A.5.5 0 006 6.5V9H4.5a.5.5 0 100 1h2a.5.5 0 00.5-.5v-3a.5.5 0 00-.508-.508z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M6.5 3C2.922 3 0 5.922 0 9.5S2.922 16 6.5 16 13 13.078 13 9.5c0-.516-.073-1.018-.187-1.5h-2.094c.167.473.281.967.281 1.5 0 2.497-2.003 4.5-4.5 4.5A4.485 4.485 0 012 9.5C2 7.003 4.003 5 6.5 5c.932 0 1.79.27 2.5.75V3.5A6.442 6.442 0 006.5 3z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} color="#000" fontWeight={400} fontSize="xx-small" fontFamily="Sans" overflow="visible" /></g></svg>;
}

export default SvgComponent;